import { Logo } from "@/components/brand/Logo";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="border-t border-border bg-background"
    >
      <div className="haevn-container flex flex-col gap-6 py-10 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <Logo />
          <span className="text-xs text-muted-foreground">
            Growth Partner Executive Brief · Draft
          </span>
        </div>
        <div className="flex flex-wrap items-center gap-6 text-xs text-muted-foreground">
          <span>Confidential</span>
          <span aria-hidden="true">·</span>
          <span>For executive review</span>
          <span aria-hidden="true">·</span>
          <span>© {new Date().getFullYear()} HAEVN</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
